import { Component } from '@angular/core';


// This component is used to handle the callback from the identity provider.
@Component({
    selector: 'app-callback',
    imports: [],
    templateUrl: './callback.component.html',
    styles: ``
})
export class CallbackComponent {

}
